import { RiskLevel } from '@models/assessment';

import { Gender } from 'generated/types';

import type { ReferenceRange } from './types';

const referenceRange: ReferenceRange<RiskLevel> = new Map([
  [
    Gender.unknown,
    new Map([
      [RiskLevel.Low, [{ upper: 5.3 }]],
      [RiskLevel.Medium, [{ lower: 5.3, upper: 6.2 }]],
      [RiskLevel.High, [{ lower: 6.2, upper: 20 }]],
    ]),
  ],
]);

export default referenceRange;
